/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class StepWiseNotifications {
    getFixupPrototypeFunction() { return StepWiseNotifications.fixupPrototype; }

    static newInstance(model: Partial<StepWiseNotifications>): StepWiseNotifications {
        let obj = Object.assign(new StepWiseNotifications(), model);
        StepWiseNotifications.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<StepWiseNotifications>): StepWiseNotifications {
        if (!model) return null;
        return StepWiseNotifications.newInstance(<StepWiseNotifications> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: StepWiseNotifications) {
        if (!obj) return;

        models.StepWiseNotifications.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: StepWiseNotifications): boolean {
        Object.setPrototypeOf(obj, StepWiseNotifications.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the step for which notification has to be sent.
     */
    step_name: string;

    /**
     * Boolean which represents the notification has been sent.
     */
    notification_sent: boolean;

}
